import { Button, Form, Input, Modal, Select, message as messager } from 'antd'
import modStyl from './edit-modal.module.scss'

import React, { useEffect, useState } from 'react'
import { createLabel, CreateLabelPayload, DataType, getLabelListTopLevel, LabelTopLevel, LabelTopLevelResult, labelTypeOptions, labelTypeTransform, updateLabel } from '../../../../services/knowledge/label';

type SelectOption = {
  label: string;
  value: number;
}

type InitialValues = {
  labelType?: number
  parentId?: number
  name: string
}

type Props = {
  record?: DataType
  onClose: (refresh: boolean)=> void
}

const CreateModal: React.FC<Props> = ({record = {id : 0 } as DataType, onClose})=> {

  const [form] = Form.useForm()

  const [disabled] = useState<boolean>(()=> record.id > 0)

  const [loading, setLoading] = useState(false)

  const [initialValues] = useState<InitialValues>(()=> {
    if (record.id === 0) {
      return {}
    }
    return {
      labelType: record.labelType,
      parentId: record.id,
    }
  })

  // 所属项目
  const [parentList, setParentList] = useState<SelectOption[]>(()=> {
    if (record.id === 0) {
      return [
        {
          label: '顶级标签',
          value: 0,
        }
      ]
    }
    return [
      {
        label: record.name,
        value: record.id,
      }
    ]
  })
  
  //
  const labelTypeChange = (value: number)=> {
    form.setFieldsValue({
      parentId: 0,
    })
    fetchParent(value)
  }

  const fetchParent = async (labelType: number)=> {
    const { code, data }: LabelTopLevelResult = await getLabelListTopLevel(labelType)
    if(code === 0) {
      setParentList([
        {
          label: '顶级标签',
          value: 0,
        },
        ...data.map(({name, id})=> ({
          value: id,
          label: name,
        }))
      ])
    }
  }

  const handleFinish = async (data: CreateLabelPayload)=> {
    setLoading(true)
    const { code } = await createLabel(data)
    setLoading(false)
    if(code === 0) {
      onClose(true)
      messager.success('新增成功')
    }
  }

  return (
    <Modal onCancel={()=> onClose(false)} visible={true} title="新增标签" footer={null} closable maskClosable={false} destroyOnClose>
      <Form onFinish={handleFinish} form={form} initialValues={initialValues} colon>
        <Form.Item label="标签名称" name="name" labelCol={{span: 8}} rules={[{required: true, message: '请输入备注信息'}]}>
          <Input placeholder='请输入标签名称'/>
        </Form.Item>
        <Form.Item label="标签类型" name="labelType" labelCol={{span: 8}} rules={[{required: true, message: '请选择所属项目'}]}>
          <Select onChange={labelTypeChange} options={labelTypeOptions} disabled={disabled} placeholder="请选择" showSearch allowClear/>
        </Form.Item>
        <Form.Item label="上级标签" name="parentId" labelCol={{span: 8}} rules={[{required: true, message: '请选择所属项目'}]}>
          <Select options={parentList} disabled={disabled} placeholder="请选择" showSearch allowClear/>
        </Form.Item>
        <div className={modStyl.footer}>
          <Button onClick={()=> onClose(false)}>取消</Button>
          <Button loading={loading} htmlType="submit" type="primary">确认</Button>
        </div>
      </Form>
    </Modal>
  )
}

export default CreateModal